export default {
  getLoyalty(state) {
    return state.loyalty;
  },
  getLoyaltyClient(state) {
    return state.loyaltyClient;
  },
  getLoyaltyClientTransactions(state) {
    return state.loyaltyClientTransactions;
  },
  getLoyaltySegmentationConfig(state) {
    return state.loyaltySegmentationConfig;
  },
  getLoyaltySegmentation(state) {
    return state.loyaltySegmentation;
  },
};
